import React from 'react';
import './SideBg.scss';
import SideBgItems from './SideBgItems/SideBgItems';
import SideBgLogo from './SideBgLogo/SideBgLogo';
import SideBgFooter from './SideBgFooter/SideBgFooter';

const SideBg = ({menuOpen, setMenuOpen}) => {
  const handleShortMenu = () => {
    setMenuOpen((prevState) => {
      const newState = !prevState;
      localStorage.setItem('shortMenu', newState);
      return newState;
    });
  };

  return (
    <div className={`side-bg ${!menuOpen ? 'short' : ''}`}>
      <SideBgLogo handleShortMenu={handleShortMenu} menuOpen={menuOpen} />
      <div className='side-bg__scroll'>
        <SideBgItems />
        <SideBgFooter />
      </div>
    </div>
  );
};

export default SideBg;
